import { useScript } from '#nuxt-scripts/composables/useScript'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const eyeableScriptDomain = useScript({"src":"https://cdn.eye-able.com/configs/awo-lausitz.de.js","key":"eyeableScriptDomain"}, { use: () => ({ eyeableScriptDomain: window.eyeableScriptDomain }) })
    const eyeableScript = useScript({"src":"https://cdn.eye-able.com/public/js/eyeAble.js","key":"eyeableScript"}, { use: () => ({ eyeableScript: window.eyeableScript }) })
    const eyeableAccess = useScript({"src":"https://access.eye-able.com/configs/awo-lausitz.de.js","key":"eyeableAccess"}, { use: () => ({ eyeableAccess: window.eyeableAccess }) })
    const eyeableTrans = useScript({"src":"https://translate-cdn.eye-able.com/eye-able-translate.js","key":"eyeableTrans"}, { use: () => ({ eyeableTrans: window.eyeableTrans }) })
    return { provide: { $scripts: { eyeableScriptDomain, eyeableScript, eyeableAccess, eyeableTrans } } }
  }
})